export const buildCreateRolloutPayload = ({
  rolloutProduct,
  rolloutReleaseVersion,
  rolloutReleaseVersionName = '',
  rolloutVersion,
  rolloutName,
  environment = '',
  bugs = [],
  tags = [],
  platform,
  rolloutDescription = '',
}) => ({
  rolloutProduct,
  rolloutReleaseVersion,
  rolloutReleaseVersionName,
  rolloutVersion,
  rolloutName,
  environment,
  bugs,
  tags,
  platform,
  rolloutDescription,
});